import { render, staticRenderFns } from "./FamiliasCRUD.vue?vue&type=template&id=5f52c620"
import script from "./FamiliasCRUD.vue?vue&type=script&lang=js"
export * from "./FamiliasCRUD.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports